import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "sender-info" }
const _hoisted_2 = {
  key: 0,
  class: "info-row"
}
const _hoisted_3 = {
  key: 1,
  class: "info-row"
}
const _hoisted_4 = {
  key: 2,
  class: "info-row"
}
const _hoisted_5 = {
  key: 3,
  class: "info-row"
}
const _hoisted_6 = {
  key: 4,
  class: "info-row"
}
const _hoisted_7 = { class: "label" }
const _hoisted_8 = {
  key: 6,
  class: "info-row"
}

import { computed } from 'vue'

interface SenderDocument {
  type: string
  series: string
  number: string
  issuer: string
  issuerCode: string
  issueDate: string
  countryCode: string
}

interface SenderData {
  firstName?: string
  lastName?: string
  middleName?: string
  birthDate?: string
  gender?: string
  citizenship?: string
  countryOfResidence?: string
  phoneNumber?: string
  documents?: SenderDocument[]
  addresses?: {
    birthPlaceAddress?: { countryCode: string; full: string }
    registrationAddress?: { countryCode: string; full: string }
  }
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ExternalNspkSender',
  props: {
    value: {}
  },
  setup(__props: any) {

const props = __props

const parsed = computed((): SenderData | null => {
  try {
    return props.value
  } catch {
    return null
  }
})

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('ru-RU')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (parsed.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (parsed.value.lastName || parsed.value.firstName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "label" }, "ФИО:", -1)),
                _createElementVNode("span", null, _toDisplayString([parsed.value.lastName, parsed.value.firstName, parsed.value.middleName].filter(Boolean).join(' ')), 1)
              ]))
            : _createCommentVNode("", true),
          (parsed.value.birthDate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "label" }, "Дата рождения:", -1)),
                _createElementVNode("span", null, _toDisplayString(formatDate(parsed.value.birthDate)), 1)
              ]))
            : _createCommentVNode("", true),
          (parsed.value.phoneNumber)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "label" }, "Телефон:", -1)),
                _createElementVNode("span", null, _toDisplayString(parsed.value.phoneNumber), 1)
              ]))
            : _createCommentVNode("", true),
          (parsed.value.citizenship)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "label" }, "Гражданство:", -1)),
                _createElementVNode("span", null, _toDisplayString(parsed.value.citizenship), 1)
              ]))
            : _createCommentVNode("", true),
          (parsed.value.gender)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "label" }, "Пол:", -1)),
                _createElementVNode("span", null, _toDisplayString(parsed.value.gender === 'MALE' ? 'Мужской' : 'Женский'), 1)
              ]))
            : _createCommentVNode("", true),
          (parsed.value.documents?.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(parsed.value.documents, (doc, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "info-row",
                  key: i
                }, [
                  _createElementVNode("span", _hoisted_7, "Документ " + _toDisplayString(i + 1) + ":", 1),
                  _createElementVNode("span", null, "Серия " + _toDisplayString(doc.series) + ", № " + _toDisplayString(doc.number) + ", выдан " + _toDisplayString(doc.issuer) + " (" + _toDisplayString(formatDate(doc.issueDate)) + ")", 1)
                ]))
              }), 128))
            : _createCommentVNode("", true),
          (parsed.value.addresses?.registrationAddress?.full)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "label" }, "Адрес:", -1)),
                _createElementVNode("span", null, _toDisplayString(parsed.value.addresses.registrationAddress.full), 1)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString(_ctx.value), 1)
        ], 64))
  ]))
}
}

})